import { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Alert,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useAuthContext } from '../../../Context/AuthContext/AuthContext';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useCompanyDocumentTradeAndCivilCreate } from '../../../rest/useCompanyInfo';
import FormHelperText from '@mui/material/FormHelperText';
import FileValidation from '../../../Components/FileValidation/FileValidation';
import DownloadIcon from '@mui/icons-material/Download';
const AddCompanyDocument = () => {
  const { user } = useAuthContext();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError: formError,
    formState: { errors },
  } = useForm();

  const { isLoading, isSuccess, mutate } =
    useCompanyDocumentTradeAndCivilCreate();
  const [ownershipStatus, setOwnershipStatus] = useState<string>('');
  const [officeAgreement, setOfficeAgreement] = useState<string>('');
  const [organizationOfficePhoto, setOrganizationOfficePhoto] = useState<any>(
    []
  );
  const [error, setError] = useState({
    ownershipStatus: false,
    officeAgreement: false,
  });

  useEffect(() => {
    if (isSuccess) {
      setOrganizationOfficePhoto([]);
    }
  }, [isSuccess]);

  const onSubmit = (data: any) => {
    if (!ownershipStatus) {
      setError({
        ...error,
        ownershipStatus: true,
      });
      return;
    }
    if (!officeAgreement) {
      setError({
        ...error,
        officeAgreement: true,
      });
      return;
    }
    const formData = new FormData();
    formData.append('ownership_status', ownershipStatus);
    formData.append('office_agreement', officeAgreement);

    Object?.keys(data)?.forEach((key) => {
      if (typeof data[key] === 'object') {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    });
    organizationOfficePhoto.forEach((img: string, index: number) => {
      const name = 'office_photographs'; /* + (index + 1) */
      formData.append(name, img);
    });

    if (user?.user_member_civil_aviation_certificate) {
      //this file is created when first time sign up. so need to take it here
      formData.append(
        'certificate_file',
        user?.user_member_civil_aviation_certificate
      );
    }
    mutate({ input: formData });
  };
  const handelOfficephotoRemove = (id: number) => {
    console.log(id, 'id');
    const restPhoto = organizationOfficePhoto.filter(
      (_img: string, index: number) => index !== id
    );
    setOrganizationOfficePhoto(restPhoto);
  };

  return (
    <Box component='form' onSubmit={handleSubmit(onSubmit)} p={2} noValidate>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Box>
            <FormControl sx={{ width: '100%' }} error={error.ownershipStatus}>
              <InputLabel id='demo-simple-select-label'>
                Select ownership status
              </InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='ownership_status'
                label='Select ownership status'
                sx={{ borderRadius: '10px' }}
                value={ownershipStatus}
                required
                onChange={(e: any) => {
                  setOwnershipStatus(e.target.value);
                  setError({
                    ...error,
                    ownershipStatus: false,
                  });
                }}
              >
                <MenuItem value={'Proprietorship'}>Proprietorship</MenuItem>
                <MenuItem value={'Partnership'}>Partnership</MenuItem>
                <MenuItem value={'Incorporator'}>Incorporator</MenuItem>
              </Select>
            </FormControl>

            {error.ownershipStatus && (
              <FormHelperText error>
                Ownership status is required
              </FormHelperText>
            )}
          </Box>

          {ownershipStatus === 'Partnership' && (
            <Box mt={2}>
              <FileValidation
                mt={'0'}
                isRequired
                register={register}
                clearErrors={clearErrors}
                setError={formError}
                errors={errors}
                label='Upload photocopy of deed of partnership ( max size 5mb )'
                fieldName={`company_partnership_deed_file`}
              />
            </Box>
          )}
          {ownershipStatus === 'Incorporator' && (
            <Box mt={2}>
              <FileValidation
                mt={'0'}
                isRequired
                register={register}
                clearErrors={clearErrors}
                setError={formError}
                errors={errors}
                label='Upload incorporation certificate ( max size 5mb )'
                fieldName={`company_incorporation_certificate`}
              />
            </Box>
          )}
          {ownershipStatus === 'Incorporator' && (
            <Box mt={2}>
              <FileValidation
                mt={'0'}
                isRequired
                register={register}
                clearErrors={clearErrors}
                setError={formError}
                errors={errors}
                label=' Upload memorandum document ( max size 5mb )'
                fieldName={`company_memorandum_file`}
              />
            </Box>
          )}
          {/* office agreement */}
          <Box mt={2}>
            <FormControl sx={{ width: '100%' }} error={error.officeAgreement}>
              <InputLabel id='demo-simple-select-label'>
                Select office agreement
              </InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                label=' Select office agreement'
                sx={{ borderRadius: '10px' }}
                value={officeAgreement}
                required
                onChange={(e: any) => {
                  setOfficeAgreement(e.target.value);
                  setError({
                    ...error,
                    officeAgreement: false,
                  });
                }}
              >
                <MenuItem value={'Self premise'}>Self premise</MenuItem>
                <MenuItem value={'Rented premise'}>Rented premise</MenuItem>
              </Select>
            </FormControl>
            {error.officeAgreement && (
              <FormHelperText error>
                OfficeAgreement status is required
              </FormHelperText>
            )}
          </Box>

          {officeAgreement && (
            <Box mt={2}>
              <FileValidation
                mt={'0'}
                isRequired
                register={register}
                clearErrors={clearErrors}
                setError={formError}
                errors={errors}
                label={
                  officeAgreement === 'self premise'
                    ? 'Upload deed of agreement of self premise office space ( max size 5mb )'
                    : 'Upload deed of agreement of rented premise office space ( max size 5mb )'
                }
                fieldName={`company_agreement_file`}
              />
            </Box>
          )}
          <Box mt={2}>
            <FileValidation
              mt={'0'}
              isRequired
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label='Upload 03 ( Three months) latest bank statement ( max size 5mb )'
              fieldName={`company_bank_statement`}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box>
            <FileValidation
              mt={'0'}
              isRequired
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label='Upload staff list on office pad with seal and signature of owner (
              max size 5mb )'
              fieldName={`company_staff_list_file`}
            />
          </Box>
          <Box mt={2}>
            <FileValidation
              mt={'0'}
              isRequired
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label=' Upload one staff any GDS (Sabre/Galileo?Amadeus) certificate ( max
              size 5mb )'
              fieldName={`company_one_staff_certificate`}
            />
          </Box>

          <Box mt={2}>
            <FileValidation
              mt='0'
              fileLimitSize={5}
              isRequired
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label='Undertaking File (Max size 5mb)'
              fieldName={`company_undertaking_file`}
              hideCustomLabel
              onlyPdf
            />
          </Box>

          <Box mt={2}>
            <a
              href='https://m360ict.s3.ap-south-1.amazonaws.com/uploads/UploadedFiles/underTakingFile/undertaking_form(2).doc'
              download='undertaking_form.doc'
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                textDecoration: 'none',
                backgroundColor: '#f2f5ef',
                color: '#573d3d',
                padding: '14px 20px',
                borderRadius: '8px',
                border: '1px solid #d3cece',
                fontSize: '15px',
                fontWeight: 'initial',
              }}
            >
              <DownloadIcon style={{ marginRight: '10px', color: 'green' }} />
              Download Undertaking Form
            </a>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 1,
              }}
            >
              {organizationOfficePhoto?.map(
                (singleImg: string | Blob, index: number) => {
                  return (
                    <Box sx={{ position: 'relative' }} key={index}>
                      <img
                        src={URL?.createObjectURL(singleImg as Blob)}
                        alt=''
                        width={100}
                        height={100}
                      />
                      <HighlightOffIcon
                        onClick={() => handelOfficephotoRemove(index)}
                        sx={{
                          position: 'absolute',
                          top: -4,
                          right: -4,
                          cursor: 'pointer',
                        }}
                      />
                    </Box>
                  );
                }
              )}
            </Box>

            <Box>
              <label htmlFor=''>
                Upload internal &#38; external photographs of office ( max size
                5mb )<span style={{ color: 'red' }}>*</span>
              </label>
              <TextField
                id='outlined-basic'
                variant='outlined'
                type='file'
                inputProps={{ accept: 'image/jpeg,image/png' }}
                required
                fullWidth
                onChange={(e: any) =>
                  setOrganizationOfficePhoto([
                    ...organizationOfficePhoto,
                    e.target.files[0],
                  ])
                }
              />
            </Box>
          </Box>

          <Box mt={2}>
            <FileValidation
              mt={'0'}
              isRequired
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label='Upload 03 ( Three months) latest sales statement ( max size 5mb )'
              fieldName={`company_sales_statement`}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid xs={12} item mt={2}>
        <Alert severity='error'>
          Note: Download the undertaking form and print the filled up form in
          300Tk Stamp with seal & signature of Owner. Finally upload and submit
          to ATAB office.
        </Alert>
      </Grid>
      {/* ------------trade license--------------- */}
      <Grid container spacing={2} mt={3}>
        <Grid item xs={12} className='text-xl text-center text-black'>
          Trade License & TIN Certificate Information
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Box>
            <label htmlFor=''>
              Trade license number <span style={{ color: 'red' }}>*</span>
            </label>

            <TextField
              id='outlined-basic'
              variant='outlined'
              placeholder='Enter trade license number '
              type='text'
              required
              fullWidth
              sx={{ pb: 2 }}
              {...register('company_trade_license', {
                required: ' Trade license number is required',
              })}
              error={
                errors.company_trade_license &&
                Boolean(errors.company_trade_license)
              }
              helperText={
                Boolean(errors?.company_trade_license?.message)
                  ? `${errors?.company_trade_license?.message}`
                  : ''
              }
            />
          </Box>
          <Box>
            <label htmlFor=''>
              TIN number <span style={{ color: 'red' }}>*</span>
            </label>
            <TextField
              id='outlined-basic'
              variant='outlined'
              placeholder='Enter tin number'
              type='number'
              required
              fullWidth
              sx={{ pb: 2 }}
              {...register('company_tin_number', {
                required: 'TIN number is required',
              })}
              error={
                errors.company_tin_number && Boolean(errors.company_tin_number)
              }
              helperText={
                Boolean(errors?.company_tin_number?.message)
                  ? `${errors?.company_tin_number?.message}`
                  : ''
              }
            />
          </Box>
          <Box>
            <FileValidation
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label='Upload BIN File / document ( max size 5mb )'
              fieldName={`company_bin_file`}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Box>
            <label htmlFor=''>
              Trade license expiry date <span style={{ color: 'red' }}>*</span>
            </label>
            <TextField
              id='date'
              type='date'
              required
              {...register('company_trade_license_expiry_date', {
                required: ' Trade license expiry date is required',
              })}
              error={
                errors.company_trade_license_expiry_date &&
                Boolean(errors.company_trade_license_expiry_date)
              }
              helperText={
                Boolean(errors?.company_trade_license_expiry_date?.message)
                  ? `${errors?.company_trade_license_expiry_date?.message}`
                  : ''
              }
              // value={date}
              // onChange={(e) => setDate(e.target.value)}
              sx={{ width: '100%', pb: 2 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box>
            <FileValidation
              isRequired
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label='Proof of Submission of Tax Return (Acknowledgement Receipt) ( max 5mb )'
              fieldName={`company_tin_file`}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Box sx={{ mb: 2 }}>
            <FileValidation
              mt={'0'}
              isRequired
              register={register}
              clearErrors={clearErrors}
              setError={formError}
              errors={errors}
              label='Upload trade license File / document ( max size 5mb )'
              fieldName={`company_trade_license_file`}
            />
          </Box>
          <Box>
            <label htmlFor=''>
              Bin number (Business Identification Number)
            </label>
            <TextField
              id='outlined-basic'
              variant='outlined'
              placeholder='Enter bin number'
              type='text'
              fullWidth
              sx={{ pb: 2 }}
              {...register('company_bin_number')}
            />
          </Box>
        </Grid>
      </Grid>
      {/* ----------civil aviation---------------------------- */}
      <Grid container spacing={2}>
        <Grid item xs={12} className='text-xl text-center text-black'>
          Civil Aviation Information
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Box>
            <label htmlFor=''>
              Civil aviation tourism certificate number{' '}
              <span style={{ color: 'red' }}>*</span>
            </label>
            <TextField
              id='outlined-basic'
              required
              variant='outlined'
              placeholder='Enter civil aviation tourism certificate number '
              fullWidth
              {...register('certificate_number', {
                required: 'Tourism certificate number is required',
              })}
              error={
                errors.certificate_number && Boolean(errors.certificate_number)
              }
              helperText={
                Boolean(errors?.certificate_number?.message)
                  ? `${errors?.certificate_number?.message}`
                  : ''
              }
            />
          </Box>
          {!user?.user_member_civil_aviation_certificate && (
            <Box sx={{ mt: 2 }}>
              <FileValidation
                mt={'0'}
                isRequired
                register={register}
                clearErrors={clearErrors}
                setError={formError}
                errors={errors}
                label='Upload civil aviation tourism certificate ( max size 5mb )'
                fieldName={`certificate_file`}
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Box>
            <label htmlFor=''>
              Civil aviation tourism issue date
              <span style={{ color: 'red' }}>*</span>
            </label>
            <TextField
              id='date'
              required
              type='date'
              {...register('certificate_issue_date', {
                required: 'Civil aviation tourism issue date is required',
              })}
              error={
                errors.certificate_issue_date &&
                Boolean(errors.certificate_issue_date)
              }
              helperText={
                Boolean(errors?.certificate_issue_date?.message)
                  ? `${errors?.certificate_issue_date?.message}`
                  : ''
              }
              // onChange={(e) =>
              //   setDate({
              //     ...date,
              //     certificate_issue_date: e.target.value,
              //   })
              // }
              sx={{ width: '100%' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          {' '}
          <Box>
            <label htmlFor=''>
              Civil aviation tourism certificate expiry date{' '}
              <span style={{ color: 'red' }}>*</span>
            </label>
            <TextField
              id='date'
              required
              type='date'
              {...register('certificate_expiry_date', {
                required: 'Civil aviation tourism expiry date is required',
              })}
              error={
                errors.certificate_expiry_date &&
                Boolean(errors.certificate_expiry_date)
              }
              helperText={
                Boolean(errors?.certificate_expiry_date?.message)
                  ? `${errors?.certificate_expiry_date?.message}`
                  : ''
              }
              // onChange={(e) =>
              //   setDate({
              //     ...date,
              //     certificate_expiry_date: e.target.value,
              //   })
              // }
              sx={{ width: '100%' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>
      </Grid>

      {!user.is_applied ? (
        <Box sx={{ mt: 2, textAlign: 'end', mb: 1 }}>
          {isLoading ? (
            <Button disabled variant='contained' disableElevation>
              Loading...
            </Button>
          ) : (
            <Button type='submit' variant='contained' disableElevation>
              Save
            </Button>
          )}
        </Box>
      ) : (
        ''
      )}
    </Box>
  );
};

export default AddCompanyDocument;
